import React, { useState, useEffect, useCallback, useRef } from "react";
import { API_BASE_URL } from "../config";
import { Button, Card, Modal } from "react-bootstrap";
import axios from "axios";
import Navbar from "./Navbar";
import Swal from "sweetalert2";
import "./AppointmentCard.css";
import { useNavigate } from "react-router-dom";
import { useLoading } from "../contexts/LoadingContext";
import { FaSearch, FaTimes } from "react-icons/fa"; // Importing a search icon
import CategoryModal from "./CategoryModal";
import Loader from "./loader";

const AppointmentCard = () => {
  const [doctors, setDoctors] = useState([]); // All doctors
  const [showModal, setShowModal] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(""); // Selected category
  const [searchValue, setSearchValue] = useState(""); // Selected category
  const [filteredDoctors, setFilteredDoctors] = useState([]); // Doctors filtered by category
  const { isLoading, setIsLoading } = useLoading();
  const [isCategoryLoading, setIsCategoryLoading] = useState(false); // New loader state for category selection
  const navigate = useNavigate();
  const searchInputRef = useRef(null);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [doctorName, setDoctorName] = useState(""); // Selected category
  // Pagination states
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const perPage = 10;
  useEffect(() => {
    setDoctors([]);
    setFilteredDoctors([]);
    setPage(1);
    setTotalPages(1);
    setTotalRecords(0);
  }, [selectedCategory]);
  useEffect(() => {
    fetchDoctors(selectedCategory, page, doctorName);
    // eslint-disable-next-line
  }, [selectedCategory, page, doctorName]);
  // Remove infinite scroll handler - no longer needed

  const handleCloseModal = () => {
    setShowModal(false);
  };
  const fetchDoctors = useCallback(
    async (category = "", pageNum = 1, doctorName) => {
      try {
        setIsLoading(true);
        if (category) {
          setIsCategoryLoading(true);
        }
        const response = await axios.get(
          `${API_BASE_URL}/specialist/list`,
          {
            params: {
              page: pageNum,
              perPage: perPage,
              speciality: category,
              doctorname: doctorName,
            },
          }
        );
        const data = response.data;
        if (data.statusCode === 1 && Array.isArray(data.payLoad)) {
          const formattedDoctors = data.payLoad.map((doctor) => ({
            applicationUserId: doctor.ApplicationUserId,
            email: doctor.Email,
            name: `${doctor.FirstName}`,
            specialty: doctor.DoctorSpecialties,
            qualifications: doctor.Allqualifications,
            DetailedInformation: doctor.DetailedInformation,
            imgLink: doctor.ImgLink,
            averageRating: doctor.AverageRating,
            doctorDutyTime: doctor.DoctorDutyTime,
            onlineStatus: doctor.OnlineDoctor,
            status: doctor.OnlineDoctor === 1 ? "online" : "offline",
            experience: doctor.Experience,
            fee: doctor.ConsultationFee,
            isDiscount: doctor.IsDiscount,
            discount: doctor.Discount,
            currency: doctor.Currency,
          }));

          setDoctors(formattedDoctors);
          setFilteredDoctors(formattedDoctors); // Set pagination info - since API doesn't provide totalRecords,
          // we'll estimate based on the current page and count
          const currentCount = data.count || formattedDoctors.length;
          setTotalRecords(currentCount);

          // If we got exactly perPage records, assume there might be more pages
          // This is a simple estimation since API doesn't provide total count
          if (formattedDoctors.length === perPage) {
            // Estimate total pages - we'll show at least current page + 1
            setTotalPages(Math.max(pageNum + 1, 2));
          } else {
            // If we got less than perPage, this is likely the last page
            setTotalPages(pageNum);
          }

          console.log("Pagination Debug:", {
            pageNum,
            formattedDoctorsLength: formattedDoctors.length,
            perPage,
            estimatedTotalPages:
              formattedDoctors.length === perPage
                ? Math.max(pageNum + 1, 2)
                : pageNum,
          });
        } else if (
          data.statusCode === 3 ||
          !Array.isArray(data.payLoad) ||
          data.payLoad.length === 0
        ) {
          setFilteredDoctors([]);
          setTotalRecords(0);
          setTotalPages(1);
        } else {
          console.log(
            "No doctors found or API response error:",
            data.statusMessage
          );
          setFilteredDoctors([]);
          setTotalRecords(0);
          setTotalPages(1);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setFilteredDoctors([]);
        setTotalRecords(0);
        setTotalPages(1);
      } finally {
        setIsLoading(false); // Hide the overall app loader
        setIsCategoryLoading(false); // Hide the category loader
      }
    },
    [setIsLoading]
  );
  const handleCategorySelect = (category) => {
    setSearchValue(category.Description);
    setSelectedCategory(category.Id); // Update the selected category
    setShowModal(false); // Close the modal after selecting a category
    setPage(1); // Reset page
    setTotalPages(1); // Reset total pages
    setTotalRecords(0); // Reset total records
  };
  const onDoctorSearch = (value) => {
    setDoctorName(value);
    setSearchValue(value);
  };
  const session = JSON.parse(sessionStorage.getItem("user"));

  const onBookAppointment = useCallback(
    (id, fee, isDiscount, discount, currency) => {
      if (!session?.payLoad.access_token) {
        Swal.fire({
          icon: "info",
          title: "Login",
          text: "Please login first",
          confirmButtonText: "OK",
          allowOutsideClick: false,
        }).then(() => {
          navigate(`/login/appointment`);
          return;
        });
      } else {
        navigate(`/selectappointment/${id}`, {
          state: { fee, isDiscount, discount, currency, id },
        });
      }
    },
    [navigate]
  );

  const handleProfileNavigation = (id) => {
    navigate(`/doctor-profile/${id}`);
  };

  const handleOpenModal = () => {
    setShowModal(true);
    if (searchInputRef.current) {
      searchInputRef.current.blur();
    }
  };
  // Fix: When clearing the category search, reset pagination and fetch all doctors
  const handleClearCategory = (e) => {
    e.stopPropagation(); // prevent opening modal
    setSearchValue("");
    setDoctorName("");
    setSelectedCategory(""); // clear the search value
    setPage(1);
    setTotalPages(1);
    setTotalRecords(0);
    setDoctors([]);
    setFilteredDoctors([]);
  };

  useEffect(() => {
    if (session) setIsLoggedIn(true);
  }, [session]);

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages && newPage !== page) {
      setPage(newPage);
      // Scroll to top when page changes
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };
  const renderPagination = () => {
    if (totalPages <= 1) return null;

    const pageNumbers = [];
    const maxVisiblePages = 5;
    let startPage = Math.max(1, page - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

    // Adjust start page if we're near the end
    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }    // Previous button
    pageNumbers.push(
      <span
        key="prev"
        className={`pagination-nav prev me-2 ${page === 1 ? 'disabled' : ''}`}
        onClick={page === 1 ? undefined : () => handlePageChange(page - 1)}
      >
        Previous
      </span>
    );    // First page if not visible
    if (startPage > 1) {
      if (page === 1) {
        pageNumbers.push(
          <Button
            key={1}
            variant="primary"
            size="sm"
            className="me-1"
            onClick={() => handlePageChange(1)}
          >
            1
          </Button>
        );
      } else {
        pageNumbers.push(
          <span
            key={1}
            className="pagination-number me-1"
            onClick={() => handlePageChange(1)}
          >
            1
          </span>
        );
      }
      if (startPage > 2) {
        pageNumbers.push(
          <span key="ellipsis1" className="me-1 ms-1">
            ...
          </span>
        );
      }
    }    // Page numbers
    for (let i = startPage; i <= endPage; i++) {
      if (page === i) {
        // Current page - show as button
        pageNumbers.push(
          <span
            key={i}
            variant="primary"
            size="sm"
            style={{ fontSize: "20px", fontWeight: "bold" }}
            className="me-1"
            onClick={() => handlePageChange(i)}
          >
            {i}
          </span>
        );
      } else {
        // Other pages - show as clickable numbers
        pageNumbers.push(
          <span
            key={i}
            className="pagination-number me-1"
            onClick={() => handlePageChange(i)}
          >
            {i}
          </span>
        );
      }
    }    // Last page if not visible
    if (endPage < totalPages) {
      if (endPage < totalPages - 1) {
        pageNumbers.push(
          <span key="ellipsis2" className="me-1 ms-1">
            ...
          </span>
        );
      }
      if (page === totalPages) {
        pageNumbers.push(
          <Button
            key={totalPages}
            variant="primary"
            size="sm"
            className="me-1"
            onClick={() => handlePageChange(totalPages)}
          >
            {totalPages}
          </Button>
        );
      } else {
        pageNumbers.push(
          <span
            key={totalPages}
            className="pagination-number me-1"
            onClick={() => handlePageChange(totalPages)}
          >
            {totalPages}
          </span>
        );
      }
    }// Next button
    pageNumbers.push(
      <span
        key="next"
        className={`d-flex align-items-center pagination-nav next ms-2 ${page === totalPages ? 'disabled' : ''}`}
        onClick={page === totalPages ? undefined : () => handlePageChange(page + 1)}
      >
        Next
      </span>
    );

    return (
      <div className="d-flex  align-items-center pagination-container">
        <div className="d-flex align-items-center">{pageNumbers}</div>
        {totalRecords > 0 && (
          <div className="pagination-info d-none d-md-block">
            Showing page {page} of {totalPages} ({totalRecords} total records)
          </div>
        )}
      </div>
    );
  };

  return (
    <>
      <Navbar />
      <div className="landing-page">
        <div className="hero-section p-2">
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <div className="row">
                  <div className="col-md-12 heading">
                    <h1>Welcome to WEBDOC HealthCare</h1>
                  </div>
                  <div className="col-md-12 sub-heading">
                    Your health is our priority. Connect with the best doctors
                    today!
                  </div>
                </div>
              </div>
              <div className="col-md-6 mt-2 d-flex justify-content-center gap-2">
                <div className="search-bar-container">
                  <form className="form-inline d-flex justify-content-center">
                    <div className="search-input-container">
                      <Button
                        style={{ color: "white", backgroundColor: "#00bcd4" }}
                        variant="link"
                        className="search-button"
                        onClick={handleOpenModal}
                      >
                        {searchValue.trim() !== "" ? searchValue : "Search"}
                        {searchValue.trim() !== "" && (
                          <FaTimes
                            className="ms-2"
                            style={{ cursor: "pointer" }}
                            onClick={handleClearCategory}
                          />
                        )}
                        <FaSearch className="search-icon ms-3" />
                      </Button>
                    </div>
                  </form>
                </div>
                {isLoggedIn && (
                  <div className="">
                    <Button
                      variant="link"
                      className="search-button"
                      onClick={() => navigate("/bookedappointment")}
                    >
                      <span>Booked Appointments</span>
                    </Button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>{" "}
      <div className="container">
        {isLoading || isCategoryLoading ? (
          <Loader type="appointment" count={3} />
        ) : filteredDoctors.length > 0 ? (
          filteredDoctors.map((doctor) => (
            <Card
              key={doctor.applicationUserId}
              className="my-3 p-3 rounded shadow-sm position-relative"
            >
              {/* Animated Ribbon Badge for Discount */}
              {doctor.isDiscount === 1 && (
                <div className="discount-ribbon-badge animated-ribbon">
                  <span>{Number(doctor.discount)}% Discount</span>
                </div>
              )}
              <Card.Body>
                <div className="row align-items-center">
                  <div className="col-md-2 text-center">
                    <img
                      src={doctor.imgLink}
                      alt={doctor.name}
                      className="img-fluid rounded-circle"
                      style={{
                        width: "100px",
                        height: "100px",
                        objectFit: "cover",
                      }}
                    />
                  </div>
                  <div className="col-md-3">
                    <div className="flex-grow-1">
                      <div className="d-flex align-items-center mb-2">
                        <h5 className="mb-0">{doctor.name}</h5>
                        {/* Removed simple badge, only ribbon will show */}
                      </div>
                      <p className="doctor-specialty text-muted">
                        {doctor.specialty}
                      </p>
                      <p className="doctor-specialty text-muted">
                        Consultation Fee:{" "}
                        {doctor.isDiscount === 1 ? (
                          (() => {
                            const originalFee = Number(doctor.fee == null ? 1000 : doctor.fee);
                            const discountRate = Number(doctor.discount);
                            const finalFee = Math.round(
                              originalFee - (originalFee * discountRate) / 100
                            );
                            return (
                              <>
                                <span
                                  style={{
                                    textDecoration: "line-through",
                                    color: "#888",
                                  }}
                                >
                                  {originalFee.toLocaleString("en-US")} {doctor.currency || "PKR"}
                                </span>
                                <span
                                  style={{
                                    color: "#4CAF50",
                                    fontWeight: "bold",
                                    marginLeft: 8,
                                  }}
                                >
                                  {finalFee.toLocaleString("en-US")} {doctor.currency || "PKR"}
                                </span>
                              </>
                            );
                          })()
                        ) : (
                          <>
                            {Number(doctor.fee == null ? 1000 : doctor.fee).toLocaleString("en-US")} {doctor.currency || "PKR"}
                          </>
                        )}
                      </p>
                      <div className="d-flex align-items-center doctor-info text-muted mt-2">
                        <div className="me-3">
                          <strong>Experience</strong>
                          <p className="doctor-details">
                            {doctor.experience}
                          </p>
                        </div>
                        <div className="separator-line mx-2"></div>
                        <div>
                          <strong>Duty Time</strong>
                          <p className="doctor-details">
                            {doctor.doctorDutyTime}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-7">
                    <p className="doctor-specialty text-muted">
                      {doctor.DetailedInformation}
                    </p>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-3 text-center">
                    <Button
                      variant="secondary"
                      className="same-size-button text-white mt-2 w-100"
                      onClick={() => {
                        onBookAppointment(
                          doctor.applicationUserId,
                          doctor.fee,
                          doctor.isDiscount,
                          doctor.discount,
                          doctor.currency
                        );
                      }}
                    >
                      Book Appointment
                    </Button>
                  </div>
                </div>
              </Card.Body>
            </Card>
          ))
        ) : (
          <div className="text-center mt-3">
            <span>No doctor found for the selected category.</span>
          </div>
        )}

        {/* Pagination Component */}
        {renderPagination()}
      </div>
      <CategoryModal
        showModal={showModal}
        closeModal={handleCloseModal}
        onCategorySelect={handleCategorySelect}
        onDoctorSearch={onDoctorSearch}
      />
    </>
  );
};

export default AppointmentCard;
